// El módulo de Administración. Sprint 1 entregó una sola pantalla; HU-23 trae la segunda.
//
// POR QUÉ APARECE ESTE ARCHIVO Y NO SE AMPLIÓ `Destinatarios`
// -----------------------------------------------------------
// Hasta ahora `modulo === 'admin'` renderizaba directamente `<Destinatarios />`: la
// entrada de menú «Administración» y la pantalla de destinatarios eran la misma cosa
// porque solo había una. Con HU-23 hay dos, y son de Features distintas (F-02 los avisos,
// F-05 la configuración regulatoria), así que el módulo necesita un contenedor.
//
// Es un cambio ADITIVO a propósito: `Destinatarios` no se toca ni una línea, sigue siendo
// la pestaña que abre por defecto, y la ruta `modulo === 'destinatarios'` —a la que llega
// el «Salir» del registro— sigue montándola suelta, sin pestañas. Quien entraba a
// Administración y veía destinatarios sigue viendo destinatarios.
//
// LAS PESTAÑAS NO SON LA AUTORIZACIÓN. `GET /sesion` decide quién ve el módulo entero
// (HU-32a) y el backend vuelve a decidirlo con el token: el router `/administracion` exige
// rol `administrador`. Esto solo organiza lo que hay dentro.
//
// SPRINT 3: se suman Usuarios (HU-32b), Maestro de productos (HU-29), Catálogos (HU-30) y
// Comité (HU-42), en el orden en que las nombra el lineamiento UX/UI. Qué pestaña abre por
// defecto y el orden final frente a las existentes es V-04 de ui/MG-ILE-58: sigue abriendo en
// Destinatarios, como antes.

import { useState } from 'react';
import { Building2, FileText, Landmark, Mail, PackageSearch, Scale, Tags, Users, UsersRound } from 'lucide-react';
import { Tabs } from '../components/ui';
import Destinatarios from './Destinatarios';
import AutoridadesYPlazos from './AutoridadesYPlazos';
import AutoridadCompetente from './AutoridadCompetente';
import ReglasDeNegocio from './ReglasDeNegocio';
import PlantillasDeCarta from './PlantillasDeCarta';
import Usuarios from './Usuarios';
import MaestroDeProductos from './MaestroDeProductos';
import Catalogos from './Catalogos';
import ComiteDeFarmacovigilancia from './ComiteDeFarmacovigilancia';

const PESTANAS = [
  // Primera a propósito: es la que el módulo abría antes de que existiera esta capa, y
  // cambiar el destino por defecto de una pantalla que la gente ya usa es una molestia
  // gratuita.
  { key: 'destinatarios', label: 'Destinatarios de avisos', icon: Mail },
  { key: 'autoridades', label: 'Autoridades y plazos', icon: Landmark },
  // Va DESPUES de «Autoridades y plazos» y no antes: alli se da de alta el nombre de
  // la autoridad, y aqui se completa como se identifica en el Formato Amarillo.
  { key: 'autoridad_competente', label: 'Autoridad competente', icon: Building2 },
  // HU-31 · las reglas de evaluación que ILENDER ajusta sin redesplegar.
  { key: 'reglas', label: 'Reglas de negocio', icon: Scale },
  // HU-45 · la carta a cada autoridad sale de su plantilla versionada (Sprint 2: 3 plantillas).
  { key: 'plantillas', label: 'Plantillas de carta', icon: FileText },
  // HU-32b · usuarios, roles (varios por persona), ámbito por rol y permiso L2.
  { key: 'usuarios', label: 'Usuarios', icon: Users },
  // HU-29 · el maestro de productos por país, desde la plantilla de Excel.
  { key: 'maestro', label: 'Maestro de productos', icon: PackageSearch },
  // HU-30 · las listas de valores de los formularios (sin País, Categoría ni Rol, C8).
  { key: 'catalogos', label: 'Catálogos', icon: Tags },
  // HU-42 · los integrantes del Comité, con su vigencia (corporativo, RN-40).
  { key: 'comite', label: 'Comité', icon: UsersRound },
];

export default function Administracion() {
  const [pestana, setPestana] = useState('destinatarios');

  return (
    <>
      <Tabs tabs={PESTANAS} active={pestana} onChange={setPestana} aria-label="Pantallas de Administración">
        <div className="mt-4">
          {pestana === 'destinatarios' && <Destinatarios />}
          {pestana === 'autoridades' && <AutoridadesYPlazos />}
          {pestana === 'autoridad_competente' && <AutoridadCompetente />}
          {pestana === 'reglas' && <ReglasDeNegocio />}
          {pestana === 'plantillas' && <PlantillasDeCarta />}
          {pestana === 'usuarios' && <Usuarios />}
          {pestana === 'maestro' && <MaestroDeProductos />}
          {pestana === 'catalogos' && <Catalogos />}
          {pestana === 'comite' && <ComiteDeFarmacovigilancia />}
        </div>
      </Tabs>
    </>
  );
}
